"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ProgressiveAssessments_exports = {};
__export(ProgressiveAssessments_exports, {
  default: () => ProgressiveAssessments_default
});
module.exports = __toCommonJS(ProgressiveAssessments_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 40 41",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M23.2458 4.42801H29.84C32.5572 4.42801 34.76 6.63077 34.76 9.34801V35.178C34.76 37.8952 32.5572 40.098 29.84 40.098H10.16C7.44275 40.098 5.23999 37.8952 5.23999 35.178V9.34801C5.23999 6.63077 7.44275 4.42801 10.16 4.42801H16.7542C16.765 4.41513 16.7712 4.39866 16.7712 4.3812V3.96676C16.7712 2.18357 18.2168 0.738008 20 0.738008C21.7832 0.738008 23.2287 2.18357 23.2287 3.96676V4.3812C23.2287 4.39866 23.235 4.41513 23.2458 4.42801Z",
      fill: "white"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.0333 3.9539C16.0402 1.76904 17.8135 0 20 0C22.1865 0 23.9598 1.76904 23.9668 3.9539L25.0039 4.42801H29.84C32.5572 4.42801 34.76 6.63077 34.76 9.34801V35.178C34.76 37.8952 32.5572 40.098 29.84 40.098H10.16C7.44275 40.098 5.23999 37.8952 5.23999 35.178V9.34801C5.23999 6.63077 7.44275 4.42801 10.16 4.42801H14.9962L16.0333 3.9539ZM12.1601 5.90401H10.16C8.25792 5.90401 6.71599 7.44594 6.71599 9.34801V35.178C6.71599 37.0801 8.25792 38.622 10.16 38.622H29.84C31.7421 38.622 33.284 37.0801 33.284 35.178V9.34801C33.284 7.44594 31.7421 5.90401 29.84 5.90401H27.84C28.7821 6.7068 29.348 7.894 29.348 9.17035C29.348 9.67605 28.9381 10.086 28.4324 10.086H11.5677C11.062 10.086 10.652 9.67605 10.652 9.17036C10.652 7.894 11.2179 6.7068 12.1601 5.90401ZM17.5093 4.38119V3.96675C17.5093 3.8595 17.516 3.75383 17.5292 3.65015C17.6847 2.42404 18.7317 1.476 20 1.476C21.3756 1.476 22.4908 2.59115 22.4908 3.96675V4.38119C22.4908 4.69853 22.6759 4.98671 22.9645 5.11866L26.2274 6.61028C27.056 6.98907 27.6389 7.73881 27.8158 8.61H12.1842C12.3611 7.73881 12.944 6.98907 13.7726 6.61028L17.0355 5.11865C17.3241 4.98671 17.5093 4.69854 17.5093 4.38119Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.08 16.113C15.08 17.8113 13.7033 19.188 12.005 19.188C10.3067 19.188 8.92999 17.8113 8.92999 16.113C8.92999 14.4147 10.3067 13.038 12.005 13.038C13.7033 13.038 15.08 14.4147 15.08 16.113Z",
      fill: "#D16D37"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.005 17.958C13.024 17.958 13.85 17.132 13.85 16.113C13.85 15.094 13.024 14.268 12.005 14.268C10.986 14.268 10.16 15.094 10.16 16.113C10.16 17.132 10.986 17.958 12.005 17.958ZM12.005 19.188C13.7033 19.188 15.08 17.8113 15.08 16.113C15.08 14.4147 13.7033 13.038 12.005 13.038C10.3067 13.038 8.92999 14.4147 8.92999 16.113C8.92999 17.8113 10.3067 19.188 12.005 19.188Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.08 24.723C15.08 26.4213 13.7033 27.798 12.005 27.798C10.3067 27.798 8.92999 26.4213 8.92999 24.723C8.92999 23.0247 10.3067 21.648 12.005 21.648C13.7033 21.648 15.08 23.0247 15.08 24.723Z",
      fill: "#D16D37"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.005 26.568C13.024 26.568 13.85 25.742 13.85 24.723C13.85 23.704 13.024 22.878 12.005 22.878C10.986 22.878 10.16 23.704 10.16 24.723C10.16 25.742 10.986 26.568 12.005 26.568ZM12.005 27.798C13.7033 27.798 15.08 26.4213 15.08 24.723C15.08 23.0247 13.7033 21.648 12.005 21.648C10.3067 21.648 8.92999 23.0247 8.92999 24.723C8.92999 26.4213 10.3067 27.798 12.005 27.798Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.08 33.333C15.08 35.0313 13.7033 36.408 12.005 36.408C10.3067 36.408 8.92999 35.0313 8.92999 33.333C8.92999 31.6347 10.3067 30.258 12.005 30.258C13.7033 30.258 15.08 31.6347 15.08 33.333Z",
      fill: "#D16D37"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.005 35.178C13.024 35.178 13.85 34.352 13.85 33.333C13.85 32.314 13.024 31.488 12.005 31.488C10.986 31.488 10.16 32.314 10.16 33.333C10.16 34.352 10.986 35.178 12.005 35.178ZM12.005 36.408C13.7033 36.408 15.08 35.0313 15.08 33.333C15.08 31.6347 13.7033 30.258 12.005 30.258C10.3067 30.258 8.92999 31.6347 8.92999 33.333C8.92999 35.0313 10.3067 36.408 12.005 36.408Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.417 16.113C17.417 15.7054 17.7474 15.375 18.155 15.375H25.535C25.9426 15.375 26.273 15.7054 26.273 16.113C26.273 16.5206 25.9426 16.851 25.535 16.851H18.155C17.7474 16.851 17.417 16.5206 17.417 16.113Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.417 33.333C17.417 32.9254 17.7474 32.595 18.155 32.595H27.995C28.4026 32.595 28.733 32.9254 28.733 33.333C28.733 33.7406 28.4026 34.071 27.995 34.071H18.155C17.7474 34.071 17.417 33.7406 17.417 33.333Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.417 24.723C17.417 24.3154 17.7474 23.985 18.155 23.985H29.225C29.6326 23.985 29.963 24.3154 29.963 24.723C29.963 25.1306 29.6326 25.461 29.225 25.461H18.155C17.7474 25.461 17.417 25.1306 17.417 24.723Z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M21.23 4.42801C21.23 5.10732 20.6793 5.65801 20 5.65801C19.3207 5.65801 18.77 5.10732 18.77 4.42801C18.77 3.7487 19.3207 3.19801 20 3.19801C20.6793 3.19801 21.23 3.7487 21.23 4.42801Z",
      fill: "currentColor"
    }
  )
);
const SvgProgressiveAssessments = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var ProgressiveAssessments_default = SvgProgressiveAssessments;
